import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_mof_approval_setting_RowClass} from '../../../dbschema';

export class MofApprovalSettingContainerModel extends BaseContainerModel {
  bl_aat_mof_approval_setting: bl_aat_mof_approval_setting_RowClass = new bl_aat_mof_approval_setting_RowClass();
}
